import listActions from 'src/modules/alexaI18n/list/alexaI18nListActions';
import AlexaI18nService from 'src/modules/alexaI18n/alexaI18nService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'ALEXAI18N_DESTROY';

const alexaI18nDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: alexaI18nDestroyActions.DESTROY_STARTED,
      });

      await AlexaI18nService.destroyAll([id]);

      dispatch({
        type: alexaI18nDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.alexaI18n.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/alexa-i18n');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: alexaI18nDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: alexaI18nDestroyActions.DESTROY_ALL_STARTED,
      });

      await AlexaI18nService.destroyAll(ids);

      dispatch({
        type: alexaI18nDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.alexaI18n.destroyAll.success'),
      );

      getHistory().push('/alexa-i18n');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: alexaI18nDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default alexaI18nDestroyActions;
